export function mega_mouseIn(event) {
$w("#mega").show();
 
}

export function mega_mouseOut(event) {$w("#mega").hide();

	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}